import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import * as styles from './product-info-price-ds.styles'

export interface BestMarketValueProps {
  pdpPriceRedesign?: boolean
}

// Third-party "Best market value" message; two call sites (festival / no-festival) render identical markup.
function BestMarketValue({ pdpPriceRedesign }: BestMarketValueProps) {
  const { t } = useTranslation('common')
  return (
    <div
      className={cx(
        styles.priceWrapperMainThirdPartyMsgCss,
        pdpPriceRedesign && styles.priceWrapperMainThirdPartyMsgPdpPriceRedesignCss,
      )}
    >
      {t('best_market_value')}
    </div>
  )
}

export default BestMarketValue
